export class InlineBase64UploadAdapter {
    constructor(private loader: any) {}

    upload(): Promise<{ default: string }> {
        return this.loader.file.then(
            (file: File) =>
                new Promise((resolve, reject) => {
                    const r = new FileReader();
                    r.onload = () => resolve({ default: r.result as string });
                    r.onerror = reject;
                    r.readAsDataURL(file);
                })
        );
    }

    abort() {}
}
